// External Imports
import { useEffect, useRef, useState } from 'react';

// Asset Imports
import DownArrowIcon from "../assets/icons/down-arrow.svg"
import CheckMarkIcon from "../assets/icons/checkmark.svg"
import "../assets/css/dropdown.scss"
import { Link } from 'react-router-dom';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';


const Dropdown = ({ options, placeholder, onChange, id }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null)
  const [showOptions, setShowOptions] = useState(false);
  const ref = useRef(null);

  function toggleOptions() {
    setShowOptions(true);
  }

  const handleOptionClose = () => {
    setShowOptions(false);
  }

  function selectOption(option) {
    setSelectedOption(option);
    setShowOptions(false);
    onChange(option);
  }


  useEffect(() => {
    const handleHoverOutside = (event) => {
        if (showOptions && ref.current && !ref.current.contains(event.target)) {
            handleOptionClose && handleOptionClose();
        }
    };
    document.addEventListener('mouseover', handleHoverOutside);
    return () => {
      document.removeEventListener('mouseover', handleHoverOutside);
    };
  }, [showOptions]);

  return (
    <div className="dropdown" ref={ref}>
      <div className={`selected-option ${selectedMenu === placeholder ? 'selected-menu': 'selected-option'}`} onClick={() => {
        setSelectedMenu(id)
        }}
        onMouseOver={toggleOptions} 
        >
        {placeholder} 
        <KeyboardArrowDownOutlined className='ms-1 bold fs-6' />
      </div>
      <div className='empty'></div>
        {(showOptions) && (
          <div className={`options-container ${id === 'business' ? 'fancy' : ''}`}>
              {id === 'business' ? (
                <div className='fancy-options'>
                  <div className='top-section'>
                    {options?.top?.map((option) => {
                      if(option?.link) {
                        return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                      } else {
                        return <a key={option.sub_title} href={option?.href} target={"_blank"} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</a>
                      }
                    })}
                  </div>
                  <hr />
                  <div className='bottom-section'>
                    <div className='left'>
                      <p className='option sub-heading w-100'>
                        {options?.left?.subHeading}
                      </p>
                      <div className='left-options'>
                        {options?.left?.list?.map((option) => {
                          // return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                          if(option?.link) {
                            return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                          } else {
                            return <a key={option.sub_title} href={option?.href} target={"_blank"} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</a>
                          }
                        })}
                      </div>
                    </div>
                    <div className='right'>
                      <div className='first'>
                        <p className='option sub-heading'>
                          {options?.rightFirst?.subHeading}
                        </p>
                        {options?.rightFirst?.list?.map((option) => {
                          if(option?.link) {
                            return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                          } else {
                            return <a key={option.sub_title} href={option?.href} target={"_blank"} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</a>
                          }
                        })}
                      </div>
                      <div className='second'>
                        <p className='option sub-heading'>
                          {options?.rightSecond?.subHeading}
                        </p>
                        {options?.rightSecond?.list?.map((option) => {
                          if(option?.link) {
                            return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                          } else {
                            return <a key={option.sub_title} href={option?.href} target={"_blank"} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</a>
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='options'>
                  {options.map((option) => {
                    if(option?.link) {
                      return <Link key={option.sub_title} to={option?.link} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</Link>
                    } else {
                      return <a key={option.sub_title} href={option?.href} target={"_blank"} className="option" onClick={() => selectOption(option)}>{option?.sub_title}</a>
                    }
                  })}
                </div>
              )}
          </div>
        )}
    </div>
  );
}

const MobileDropdown = ({ options, placeholder, setShowMobileMenu, id }) => {
  const [showOptions, setShowOptions] = useState(false);

  function toggleOptions() {
    setShowOptions(!showOptions);
  }

  return (
    <div className="mobile-dropdown">
      <div className='mobile-selected-option' onClick={() => {
        toggleOptions()
        }}
        >
        {placeholder} 
       { !showOptions  ? <KeyboardArrowDownOutlined className='ms-1 bold fs-6' /> : <KeyboardArrowUpOutlined className='ms-1 bold fs-6' />}
      </div>
      {(showOptions) && (
        <div className='mobile-options'>
          {id === 'business' ?  (
            <>
              {options?.top?.map((option) => {
                  if(option?.link) {
                    return( 
                      <div>
                        <Link to={option?.link} className="mobile-option" onClick={() => setShowMobileMenu(false)}>   
                          {option?.sub_title}
                        </Link>
                      </div>
                    ) 
                  }else{
                    return(
                    <div>
                      <a href={option?.href} target={"_blank"} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                        {option?.sub_title}
                        </a>
                    </div>
                    )
                  }
              })}
              <hr />
              <p className="mobile-option sub-heading">{options?.left?.subHeading}</p>
              {options?.left?.list?.map((option) => {
                if(option?.link) {
                  return(
                      <div>
                        <Link to={option?.link} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </Link>
                      </div>
                  )
                }else{
                  return(
                      <div>
                        <a href={option?.href} target={"_blank"} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </a>
                      </div>
                  )
                }
              })}
              <hr />
              <p className='mobile-option sub-heading'>
                {options?.rightFirst?.subHeading}
              </p>
              {options?.rightFirst?.list?.map((option) => {
                if(option?.link) {
                  return(
                      <div>
                        <Link to={option?.link} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </Link>
                      </div>
                  )
                }else{
                  return(
                      <div>
                        <a href={option?.href} target={"_blank"} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </a>
                      </div>
                  )
                }
              })}
              {/* <hr /> */}
              <p className='mobile-option sub-heading'>
                {options?.rightSecond?.subHeading}
              </p>
              {options?.rightSecond?.list?.map((option) => {
                if(option?.link) {
                  return(
                      <div>
                        <Link to={option?.link} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </Link>
                      </div>
                  )
                }else{
                  return(
                      <div>
                        <a href={option?.href} target={"_blank"} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                          {option?.sub_title}
                        </a>
                      </div>
                  )
                }
              })}
            </>
          ): options.map((option) => {
            if(option?.link) {
              return( 
                <div>
                  <Link to={option?.link} className="mobile-option" onClick={() => setShowMobileMenu(false)}>   
                    {option?.sub_title}
                  </Link>
                </div>
              ) 
            }else{
              return(
              <div>
                <a href={option?.href} target={"_blank"} className="mobile-option" onClick={() => setShowMobileMenu(false)}>
                  {option?.sub_title}
                  </a>
              </div>
              )
            }
          })}
        </div>
      )}
    </div>
  );
}

const FilledDropdown = ({ options, placeholder, onChange, className, optionClassName, optionChosen, disabled}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showOptions, setShowOptions] = useState(false);

  function toggleOptions() {
    setShowOptions(!showOptions);
  }

  function selectOption(option) {
    setSelectedOption(option);
    setShowOptions(false);
    onChange(option);
  }


  return (
    <div className={`filled-dropdown ${className} ${showOptions && 'dropdown-bottom-radius'}`}>
        <div className={`selected-option ${disabled && 'disabled-selected-option'}`} onClick={toggleOptions}>
          { optionChosen || <span style={{color: 'rgba(56, 62, 86, 0.5)'}}>{placeholder}</span>}
          <img src={DownArrowIcon} className="ms-2 arrow" />
        </div>
      {showOptions && (
        <div className={`options ${optionClassName}`}>
          {options.map(option => (
            <div
              key={option}
              className="option"
              onClick={() => selectOption(option)}
            >
              {option}
              {
                (option === optionChosen) && <img src={CheckMarkIcon} alt="check mark" />
              }
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
export { FilledDropdown, MobileDropdown };
